import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import ByggIcon from '../../../images/Bygg_white.png'

class Bygg extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleBygg = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    showBygg = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowBygg,
                bygg: this.props.bygg
            }
        })
    }

    render() {
        const { t } = this.props
        var bygg = this.props.bygg
        var oppvarmingstyper = bygg.oppvarmingstyper ? bygg.oppvarmingstyper.map(o => o.oppvarmingsKode).join(', ') : '';
        var energikilder = bygg.energikilder ? bygg.energikilder.map(e => e.energikildeKode).join(', ') : '';
        var bygningsstatus = bygg.bygningsstatusKode.substr(0, bygg.bygningsstatusKode.indexOf(' '));

        return (
            <li>
                <div className="section-header mainsection" onClick={this.toggleBygg}>
                    <div className="icon-image"><img src={ByggIcon} /></div>
                    <span className="title">{bygg.bygningstypeKode} - {bygningsstatus} - {bygg.bygningsnummer}</span>
                    <span className="icon right"><i className={`fa fa-${this.state.isOpened ? 'minus' : 'plus'}-circle`}></i></span>
                    <div className="icon right tooltip" onClick={this.showBygg}><i className="fa fa-map-marker-alt"></i>
                        <div className="tooltip-content">{t('vis.bygg')}</div>
                    </div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{bygg.kommunenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bygningsnr')}</div>
                            <div className="value">{bygg.bygningsnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bygningstype')}</div>
                            <div className="value">{bygg.bygningstypeKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bygningsstatus')}</div>
                            <div className="value">{bygg.bygningsstatusKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('sefrakminne')}</div>
                            <div className="value">{bygg.harSefrakminne ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kulturminne')}</div>
                            <div className="value">{bygg.harKulturminne ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('ufullstendigareal')}</div>
                            <div className="value">{bygg.ufullstendigAreal ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealbolig')}</div>
                            <div className="value">{bygg.bruksarealTilBolig}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruksarealannet')}</div>
                            <div className="value">{bygg.bruksarealTilAnnet}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealtotalt')}</div>
                            <div className="value">{bygg.bruksarealTotalt}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('alternativtareal')}</div>
                            <div className="value">{bygg.alternativtAreal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('alternativtareal2')}</div>
                            <div className="value">{bygg.alternativtAreal2}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealbolig')}</div>
                            <div className="value">{bygg.bruttoarealTilBolig}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruttoarealannet')}</div>
                            <div className="value">{bygg.bruttoarealTilAnnet}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealtotalt')}</div>
                            <div className="value">{bygg.bruttoarealTotalt}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('antallbruksenheter')}</div>
                            <div className="value">{bygg.antallBruksenheter}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('antallboenheter')}</div>
                            <div className="value">{bygg.antallBoenheter}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bebygdareal')}</div>
                            <div className="value">{bygg.bebygdAreal}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('harheis')}</div>
                            <div className="value">{bygg.harHeis ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('vannforsyning')}</div>
                            <div className="value">{bygg.vannforsyningsKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('avlop')}</div>
                            <div className="value">{bygg.avlopsKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('energikilder')}</div>
                            <div className="value">{energikilder}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('oppvarmingstyper')}</div>
                            <div className="value">{oppvarmingstyper}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Bygg)